// Copyright (c) 2016 Deere & Company

import basicWarrantyEstimator from './basic-warranty-estimator';
import dealerTransferHistory from './dealer-transfer-history';
import deliveryNoDocuments from './delivery-no-documents';
import demoRentalHistory from './demo-rental-history';
import duplicatePinPlate from './duplicate-pin-plate';
import {getIsPinTransferEnabled} from '../../../product/shared/services/get-is-pin-transfer-enabled-aor';
import maintenancePlan from './maintenance-plan';
import massChannelCustomerFollowUp from './mass-channel-customer-follow-up';
import pinCrossReference from './pin-cross-reference';
import pinsNotRegistered from './pins-not-registered';
import registrationsReview from './registrations-review';
import responsibleDealer from './responsible-dealer';
import settlementNoRegistration from './settlement-no-registration';
import updateMachineStatusHistory from './update-machine-status-history';
import warrantyExpiration from './warranty-expiration';

/* eslint-disable sorting/sort-object-props */

export default () => {

    const reports = {
        childRoutes: [
            registrationsReview,
            pinsNotRegistered,
            massChannelCustomerFollowUp,
            basicWarrantyEstimator,
            settlementNoRegistration,
            dealerTransferHistory,
            updateMachineStatusHistory,
            maintenancePlan,
            deliveryNoDocuments,
            demoRentalHistory,
            warrantyExpiration,
            pinCrossReference,
            duplicatePinPlate
        ]
    };

    if (getIsPinTransferEnabled('responsible-dealer-report')) {

        reports.childRoutes.push(responsibleDealer);

    }

    return reports;

};

/* eslint-enable sorting/sort-object-props */



// WEBPACK FOOTER //
// ./src/routes/products/reports/index.js